import { CircularProgress } from '@mui/material'
import { AppButton } from '../button'
import { useStyles } from './styles'

type ModalProps = {
  isOpen: boolean
  title: string | React.ReactNode
  content: string
  btnText?: string
  onClose?: () => void
  onClick?: () => void
  btnType?: 'primary' | 'secondary'
  img?: string
  classes?: Record<string, string>
  children?: React.ReactNode
  contentChildren?: React.ReactNode
  backdropClass?: string
  isClickableOutside?: boolean
  crossShowed?: boolean
  isLoading?: boolean
  closeOnClick?: boolean
}
export const Modal = (props: ModalProps) => {
  const {
    isOpen,
    content,
    title,
    onClose,
    onClick,
    btnText,
    btnType = 'primary',
    img,
    classes: propClasses,
    isClickableOutside = true,
    children,
    contentChildren,
    backdropClass,
    crossShowed = 'true',
    closeOnClick = true,
  } = props
  const { classes } = useStyles({ classesOverrides: propClasses })

  return (
    <div
      data-open={isOpen}
      className={`${backdropClass ? backdropClass : classes.backdrop} ${classes.zIndex}`}
    >
      {isClickableOutside && (
        <span
          className={classes.clickhelper}
          onClick={() => {
            if (onClose) onClose()
          }}
        />
      )}
      <>{children}</>
      <div
        data-open={isOpen}
        className={classes.root}
      >
        <div className={classes.header}>
          {img && (
            <div className={classes.steamLogo}>
              <img
                src={img}
                alt=""
                className={classes.steamLogo}
              />
            </div>
          )}
          <div className={classes.title}>
            {title}
            {crossShowed && (
              <div
                className={classes.closeBtn}
                onClick={() => {
                  if (onClose) onClose()
                }}
              >
                X
              </div>
            )}
          </div>
        </div>

        <div className={classes.text}>{content}</div>
        <>{contentChildren}</>
        <div className={classes.btnContainer}>
          <AppButton
            variant={btnType}
            fullWidth
            sx={{
              height: '52px',
            }}
            isLoading={props.isLoading}
            onClick={() => {
              if (closeOnClick) {
                if (onClose) {
                  onClose()
                }
              }
              if (onClick) {
                onClick()
              }
            }}
          >
            {props.isLoading ? (
              <CircularProgress
                sx={{ color: (props.isLoading && btnType === 'secondary' && '#101010') || 'inherit' }}
                size={24}
              />
            ) : btnText ? (
              btnText
            ) : (
              'OK'
            )}
          </AppButton>
        </div>
      </div>
    </div>
  )
}
